import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableContainer from '../general/TableContainer';
import MachineDetails from './MachineDetails';
import InsertMachine from './InsertMachine';
import Modal from '../general/Modal';
import UploadMachines from './UploadMachines';
import OrderManagement from './OrderManagement';
import InsertCorrectivo from './InsertCorrectivo';
import { fetchMachines, fetchMachinesSuccess, fetchMachinesFailure, selectSubMenu, fetchOrders, fetchOrdersSuccess, fetchOrdersFailure, fetchTaskTypeSuccess, setData} from '../../actions';
import { getGenerateOrders, getOrdersByCompany, deleteMachines, getMachines, getHistoriesByEmpresa} from '../general/api'; // Importa las funciones de API
import '../Home.css';
import HistoryDetail from './HistoryDetail';



const Mantenimiento = ({ submenu = 'ordenes' }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const machines = useSelector((state) => state.machine.machines);
    const orders = useSelector((state) => state.machine.orders);
    const Actualizar = useSelector((state) => state.menu.data);
    const [historial, setHistorial] = useState([]);
    const [filteredHistory, setFilteredHistory] = useState([]);
    const loading = useSelector((state) => state.machine.loading);
    const permissions = useSelector((state) => state.access.permissions);
    const [selectedFilas, setSelectedFilas] = useState(null);
    const [navigationHistory, setNavigationHistory] = useState([submenu]);
    const [showModal, setShowModal] = useState(false);
    const [isOMEdit, setIsOMEdit] = useState(false);
    const [boton, setBoton] = useState(null);
    

    // Utiliza las funciones de API desde api.js
    const fetchGenerateOrders = async () => {
        try {
            const data = await getGenerateOrders(user.Id_Empresa);
            dispatch(fetchTaskTypeSuccess(data));
        } catch (error) {
            console.log(error.message);
        }
    };

    const fetchOrdersData = async () => {
        try {
            const data = await getOrdersByCompany(user.Id_Empresa);
            if (data && Array.isArray(data)) {
                const requiredPermissions = ['viewMantenimiento', 'updateMachines', 'deleteMachines', 'insertMachines'];
                const missingPermissions = requiredPermissions.filter(permission => !permissions.includes(permission));
                if (missingPermissions.length === 0) {
                    dispatch(fetchOrdersSuccess(data));
                } else {
                    dispatch(fetchOrdersSuccess(data.filter(item => item.Assigned_User === user.Id_User || item.Status === 'Pendiente' )));
                }
            } else {
                dispatch(fetchOrdersFailure("Error: No hay órdenes para esta empresa u ocurrio un error al consultar"));
            }
        } catch (error) {
            dispatch(fetchOrdersFailure(error.message));
        }
    };

    const deleteMachine = async (userId, selectedMachines) => {
        try {
            const result = await deleteMachines(userId, selectedMachines);
            if (result.Success) {
                alert(JSON.stringify(result.Success));
                fetchMachinesData(); // Actualizar la lista de máquinas después de eliminar
                setSelectedFilas(null);
            }
        } catch (error) {
            console.error(error);
            alert('No se borraron máquinas o no se seleccionó máquina alguna');
        }
        dispatch(setData('Maquinas'));
    };

    const fetchMachinesData = async () => {
        try {
            const data = await getMachines(user.Id_User);
            if (data && Array.isArray(data)) {
                dispatch(fetchMachinesSuccess(data));
            } else {
                dispatch(fetchMachinesFailure("Error: No hay maquinas para esta empresa u ocurrio un error al consultar"));
            }
        } catch (error) {
            dispatch(fetchMachinesFailure(error.message));
        }
    };

    const fetchHistory = async () => {
        try {
            setHistorial(await getHistoriesByEmpresa(user.Id_Empresa));
            filtarHistorial();
        } catch {
            console.log('Error al obtener historial');
        } 
    };

    const filtarHistorial = () => {
        const historialFiltrado = historial.reduce((acc, curr) => {
            if (!acc[curr.Id_Order] || new Date(curr.Timestamp) > new Date(acc[curr.Id_Order].Timestamp)) {
                acc[curr.Id_Order] = curr;
            }
            return acc;
        }, {});
    
        setFilteredHistory(Object.values(historialFiltrado));
    };

    useEffect(() => {
        if (user && user.Id_User) {
            dispatch(fetchMachines());
            dispatch(fetchOrders());
        } else {
            dispatch(fetchMachinesFailure("Error: No hay usuario logueado"));
        }
    }, [dispatch, user, submenu]);

    useEffect(() => {
        fetchGenerateOrders();
        fetchMachinesData();
        fetchOrdersData();
        dispatch(setData(''));
    }, [Actualizar]);



    const tableColumns = [
        { header: 'Fecha de Instalación', field: 'Inst_Date_Machine' },
        { header: 'Código Interno', field: 'Internall_Code_Machine' },
        { header: 'Ubicación', field: 'Location_Machine' },
        { header: 'Nombre', field: 'Name_Machine' },
        { header: 'Observación', field: 'Observation_Machine' },
        { header: 'Prioridad', field: 'Priority_Machine', visible: false},
        { header: 'Referencia', field: 'Ref_Machine' },
        { header: 'Estado', field: 'State_Machine' },
        { header: 'Imagen', field: 'Path_Photo_Machine', visible: false},
        { header: 'Manual pdf', field: 'Path_Manual_Machine', visible: false}
    ];

    const tableColumnsOrders = [
        { header: 'Orden', field: 'Id_Order'},
        { header: 'Código de Tarea', field: 'Internal_Code' },
        { header: 'Codigo de Maquína', field: 'Internall_Code_Machine'},
        { header: 'Tipo de Tarea', field: 'Name_Task_Type' },
        { header: 'Fecha Programada', field: 'Scheduled_Date' },
        { header: 'Estado', field: 'Status' },
        { header: 'Usuario Asignado', field: 'Name_User' },
        { header: 'Descripción de la Tarea', field: 'Description', visible: false },
        { header: 'Insumos usados', field: 'Supplies', visible: false },
      ];

    const tableColumnsHistory = [
      { header: 'Historial', field: 'Id_History', visible: false },
      { header: 'Orden', field: 'Id_Order'},
      { header: 'Código de Tarea', field: 'Id_Task', visible: false},
      { header: 'Descripción de la Tarea', field: 'Description_Task' },
      { header: 'Código de Máquina', field: 'Id_Machine', visible: false},
      { header: 'Nombre de Máquina', field: 'Name_Machine' },
      { header: 'Empresa', field: 'Name_Emp', visible: false },
      { header: 'Usuario Asignado', field: 'Name_User' },
      { header: 'Fecha Programada', field: 'Scheduled_Date' },
      { header: 'Estado', field: 'Status' },
      { header: 'Prioridad', field: 'Priority', visible: false},
      { header: 'Observaciones', field: 'Observation'},
      { header: 'Marca de Tiempo', field: 'Timestamp'}
    ];
    
    const handleRowDoubleClick = (row) => {
        setBoton(null);
        if (submenu === 'maquinas'){
            setSelectedFilas(row);
            dispatch(selectSubMenu('machineDetails')); // Despacha la acción para seleccionar el submenú
        }else if (submenu === 'ordenes'){
            setIsOMEdit(false);
            setSelectedFilas([row]);
            setShowModal(true);
        }else if (submenu === 'historialMantenimiento'){
            setShowModal(true);
        }    
    };

    const handleRowClick = (row) => {
        setSelectedFilas(row);
    };

    const handleButtonClick = (button, datos = null) => {
        setBoton(button);
        if (button === 'add') {
            if (submenu === 'maquinas'){
                dispatch(selectSubMenu('insertMachine'));
            }if (submenu=== 'ordenes'){
                setShowModal(true);
            }else{
                console.log('Button add clicked' );
            }
        } else if (button === 'edit') {
            if (submenu=== 'ordenes'){
                if(selectedFilas){
                    setIsOMEdit(true);
                    setShowModal(true);
                }
            }else{
                console.log(`Button edit clicked`);
            }
        } else if (button === 'delete') {
           // Lógica para eliminar una máquina 
            if (selectedFilas && submenu === 'maquinas') { 
                deleteMachine(user.Id_User, selectedFilas); 
            }else { 
                alert('Seleccione una máquina para eliminar.'); 
            }
        } else if (button === 'import') {
            if ( submenu === 'maquinas'){   
             setShowModal(true);
            }else{
                console.log(`Button import clicked`);
            }
        } else if (button === 'export') {
            // Lógica para exportar máquinas
            console.log(`Button export clicked`);
            console.log(datos);
        }
    };

    // Construir buttonList basado en los permisos
    const buttonList = [];
    if (permissions.includes('insertMachines')) {
        buttonList.push('add');
    }
    if (permissions.includes('updateMachines')) {
        buttonList.push('import');
        buttonList.push('edit');
    }
    if (permissions.includes('deleteMachines')) {
        buttonList.push('delete');
    } // Asumo que 'import' y 'export' son siempre necesarios

    useEffect(() => {
        if (submenu=== 'ordenes'){
            setSelectedFilas(null);
        }else if (submenu !== 'maquinas' && submenu !== 'machineDetails' && submenu !== 'insertMachine' && submenu !== 'historialMantenimiento'){
            dispatch(selectSubMenu('ordenes'));
        } 
        setShowModal(false);
        fetchMachinesData();
        fetchGenerateOrders();
        fetchOrdersData();
        fetchHistory();
        setNavigationHistory((prevHistory) => {
            const newHistory = [...prevHistory];
            const index = newHistory.indexOf(submenu);
            if (index !== -1) {
                newHistory.splice(index, 1); // Eliminar si ya existe
            }
            newHistory.push(submenu); // Agregar al final
            return newHistory;
        });
    }, [dispatch, submenu]);

    const handleCloseModal = () => {
        setShowModal(false);
    }
 
    return (
        <div>
            <div className="home">
                <h2 className="home-pag-name">Mantenimiento</h2>
                {submenu === 'maquinas' ? (
                    <>
                        <Modal show={showModal} handleClose={handleCloseModal}> 
                            <UploadMachines handleCloseModal={handleCloseModal} /> 
                        </Modal>
                        <TableContainer
                            title="Inventario de Maquinas y Herramientas"
                            rowEdit={selectedFilas}
                            data={machines}
                            columns={tableColumns}
                            onRowClick={handleRowClick}
                            onRowDoubleClick={handleRowDoubleClick}
                            handleButtonClick={handleButtonClick}
                            loading={loading}
                            error={machines && machines.length > 0 ? '' : 'No hay maquinas u ocurrio un error al consultar'}
                            className="mantenimiento-table"
                            buttonList={buttonList.filter(button => button !== 'edit')}
                            navigationHistory={navigationHistory} // Pasa el historial de navegación
                            showPieChart = {true}
                        />
                    </>
                ) : submenu === 'machineDetails' && selectedFilas ? (
                    <MachineDetails
                        user={user.Id_User}
                        machine={selectedFilas}
                        buttonList={buttonList}
                        navigationHistory={navigationHistory} // Pasa el historial de navegación
                        deleteMachine={deleteMachine}
                    />
                ) : submenu === 'insertMachine' ? (
                    <InsertMachine  
                        navigationHistory={navigationHistory} // Pasa el historial de navegación
                    />
                ) : submenu === 'ordenes' ? (
                    <>
                        <Modal show={showModal} handleClose={handleCloseModal}> 
                            {submenu=== 'ordenes' && boton === 'add' ?(
                                <InsertCorrectivo navigationHistory={handleCloseModal} />
                            ):(
                                <OrderManagement navigationHistory={handleCloseModal} isEdit={isOMEdit} order={selectedFilas}/>
                                )}
                        </Modal>
                        <TableContainer
                            title="Ordenes de mantenimiento"
                            data={orders}
                            columns={tableColumnsOrders}
                            onRowClick={handleRowClick}
                            onRowDoubleClick={handleRowDoubleClick}
                            handleButtonClick={handleButtonClick}
                            loading={loading}
                            error={orders && orders.length > 0 ? '' : 'No hay ordenes de mantenimiento al consultar'}
                            className="mantenimiento-table"
                            buttonList= {buttonList.filter(button => button !== 'import').filter(button => button !== 'delete')}
                            navigationHistory={navigationHistory} // Pasa el historial de navegación
                            showPieChart = {true}
                        />
                    </>
                ) : (
                    <>
                        <Modal show={showModal} handleClose={handleCloseModal}> 
                            <HistoryDetail 
                                history={historial}
                                filterParam = 'Id_Order'
                                filterValue = {selectedFilas && selectedFilas[0] && selectedFilas[0].Id_Order ? selectedFilas[0].Id_Order : '' }
                                handleClose={handleCloseModal}
                            />
                        </Modal>
                        <TableContainer
                            title="Historial de mantenimiento"
                            data={filteredHistory}
                            columns={tableColumnsHistory}
                            onRowClick={handleRowClick}
                            onRowDoubleClick={handleRowDoubleClick}
                            handleButtonClick={handleButtonClick}
                            loading={loading}
                            error={filteredHistory && filteredHistory.length > 0 ? '' : 'No hay historial de mantenimiento al consultar'}
                            className="mantenimiento-table"
                            buttonList= {buttonList.filter(button => button !== 'import').filter(button => button !== 'delete').filter(button => button !== 'edit').filter(button => button !== 'add')}
                            navigationHistory={navigationHistory} // Pasa el historial de navegación
                            showPieChart = {true}
                        />
                    </>
                )}
            </div>
        </div>
    );
    }
    
    export default Mantenimiento;
    
